class LRUNode {
  key: string
  value: string
  pre: LRUNode | null
  nxt: LRUNode | null
  constructor(k: string, v: string) {
    this.key = k
    this.value = v
    this.pre = null
    this.nxt = null
  }

  public deleteSelf() {
    const pre: LRUNode | null = this.pre
    const nxt: LRUNode | null = this.nxt
    if (pre !== null) {
      pre.nxt = nxt
    }
    if (nxt !== null) {
      nxt.pre = pre
    }
  }

  public addAfter(n: LRUNode) {
    const pre: LRUNode | null = n
    const nxt: LRUNode | null = n.nxt
    this.pre = pre
    this.nxt = nxt
    pre.nxt = this
    if (nxt !== null) {
      nxt.pre = this
    }
  }
}
export default class LRUCache {
  private readonly map: Map<string, LRUNode>
  private size: number
  private readonly capacity: number
  private readonly head: LRUNode
  private readonly tail: LRUNode
  constructor(capacity: number) {
    this.map = new Map<string, LRUNode>()
    this.head = new LRUNode('#', '#')
    this.tail = new LRUNode('#', '#')
    this.head.nxt = this.tail
    this.tail.pre = this.head
    this.capacity = capacity < 0 ? 0 : capacity
    this.size = 0
  }

  public deleteKey(key: string) {
    if (key === null) {
      return
    }
    if (this.map.has(key)) {
      const del: LRUNode | undefined = this.map.get(key)
      if (del == null) {
        return
      }
      del.deleteSelf()
      this.size--
      this.map.delete(del.key)
    }
    else {

    }
  }

  public get(key: string): string {
    if (key === null) {
      return 'MISS'
    }
    if (this.map.has(key)) {
      const cur: LRUNode | undefined = this.map.get(key)
      if (cur == null) {
        return 'MISS'
      }
      const ret: string = cur.value
      cur.deleteSelf()
      cur.addAfter(this.head)
      return ret
    }
    else return 'MISS'
  }

  public put(key: string, value: string) {
    if (key === null || value === null) {
      return
    }
    if (this.map.has(key)) {
      const del: LRUNode | undefined = this.map.get(key)
      if (del == null) {
        return
      }
      del.deleteSelf()
      this.size--
      this.map.delete(del.key)
    }
    if (this.size > 0 && this.size === this.capacity) {
      const del: LRUNode | null = this.tail.pre
      if (del === null) {
        return
      }
      del.deleteSelf()
      this.size--
      this.map.delete(del.key)
    }
    const node: LRUNode = new LRUNode(key, value)
    node.addAfter(this.head)
    this.map.set(key, node)
    this.size++
  }

  public getValueArray(): string[] {
    let p: LRUNode | null = this.head.nxt
    const res = []
    while (p !== null && p !== this.tail) {
      res.push(p.value)
      p = p.nxt
    }
    return res
  }

  public clear() {
    let p: LRUNode | null = this.head.nxt
    while (p !== null && p !== this.tail) {
      p?.deleteSelf()
      p = p?.nxt
    }
    this.map.clear()
  }
}
